export const quickKeyButtons = [
  { name: '0', value: '0' },
  { name: '1', value: '1' },
  { name: '2', value: '2' },
  { name: '3', value: '3' },
  { name: '4', value: '4' },
  { name: '5', value: '5' },
  { name: '6', value: '6' },
  { name: '7', value: '7' },
  { name: '8', value: '8' },
  { name: '9', value: '9' },
  { name: 'a', value: 'a' },
  { name: 'b', value: 'b' },
  { name: 'c', value: 'c' },
  { name: 'd', value: 'd' },
  { name: 'e', value: 'e' },
  { name: 'f', value: 'f' },
  { name: 'g', value: 'g' },
  { name: 'h', value: 'h' },
  { name: 'i', value: 'i' },
  { name: 'j', value: 'j' },
  { name: 'k', value: 'k' },
  { name: 'l', value: 'l' },
  { name: 'm', value: 'm' },
  { name: 'n', value: 'n' },
  { name: 'o', value: 'o' },
  { name: 'p', value: 'p' },
  { name: 'q', value: 'q' },
  { name: 'r', value: 'r' },
  { name: 's', value: 's' },
  { name: 't', value: 't' },
  { name: 'u', value: 'u' },
  { name: 'v', value: 'v' },
  { name: 'w', value: 'w' },
  { name: 'x', value: 'x' },
  { name: 'y', value: 'y' },
  { name: 'z', value: 'z' },
  { name: '⎵', value: '\\, ' },
];

export const quickSymbolButtons = [
  { value: '=', name: '=' },
  { value: '+', name: '+' },
  { value: '-', name: '-' },
  { value: '\\times\\,', name: '×' },
  { value: '\\div\\,', name: '÷' },
  { value: '/', name: '/' },
  { value: '\\frac', name: '—' },
  { value: '\\pm\\, ', name: '±' },
  { value: '\\mp\\, ', name: '∓' },
  { value: '\\ast\\,', name: '*' },
  { value: '\\%', name: '%' },
  { value: '\\neq\\,', name: '≠' },
  { value: '\\approx\\,', name: '≈' },
  { value: '>', name: '>' },
  { value: '<', name: '<' },
  { value: '\\geq\\, ', name: '≥' },
  { value: '\\leq\\,', name: '≤' },
  { value: '\\wedge\\,', name: '^' },
  { value: '\\vee\\,', name: '∨' },
  { value: '( \\,', name: '(' },
  { value: '\\, ) \\,', name: ')' },
  { value: '[ \\,', name: '[' },
  { value: '\\, ] \\,', name: ']' },
  { value: '\\{', name: '{' },
  { value: '\\}', name: '}' },
  { value: '\\lfloor\\,', name: '⌊' },
  { value: '\\rfloor\\,', name: '⌋' },
  { value: '\\lceil\\,', name: '⌈' },
  { value: '\\rceil\\,', name: '⌉' },
  { value: '\\Sigma\\,', name: 'Σ' },
  { value: '.', name: '.' },
  { value: 'x', name: 'x' },
  { value: 'y', name: 'y' },
  { value: 'z', name: 'z' },
  { value: 'x^2', name: 'x²' },
  { value: 'x^3', name: 'x³' },
  { value: 'A^a', name: 'Aª' },
  { value: '\\sqrt', name: '√' },
  { value: '\\sqrt[3]', name: '3√' },
  { value: '\\pi\\,', name: 'π' },
  { value: '\\infty\\,', name: '∞' },
];

export const greekButtons = [
  { value: '\\alpha\\,', name: 'α' },
  { value: '\\beta\\,', name: 'β' },
  { value: '\\gamma\\,', name: 'γ' },
  { value: '\\delta\\,', name: 'δ' },
  { value: '\\epsilon\\,', name: 'ε' },
  { value: '\\zeta\\,', name: 'ζ' },
  { value: '\\eta\\,', name: 'η' },
  { value: '\\theta\\,', name: 'θ' },
  { value: '\\iota\\,', name: 'ι' },
  { value: '\\kappa\\,', name: 'κ' },
  { value: '\\lambda\\,', name: 'λ' },
  { value: '\\mu\\,', name: 'μ' },
  { value: '\\nu\\,', name: 'ν' },
  { value: '\\xi\\,', name: 'ξ' },
  { value: '\\omicron\\,', name: 'ο' },
  { value: '\\pi\\,', name: 'π' },
  { value: '\\rho\\,', name: 'ρ' },
  { value: '\\sigma\\,', name: 'σ' },
  { value: '\\tau\\,', name: 'τ' },
  { value: '\\upsilon\\,', name: 'υ' },
  { value: '\\phi\\,', name: 'φ' },
  { value: '\\chi\\,', name: 'χ' },
  { value: '\\psi\\,', name: 'ψ' },
  { value: '\\omega\\,', name: 'ω' },
  { value: 'Α', name: 'Α' },
  { value: 'Β', name: 'Β' },
  { value: '\\Gamma\\,', name: 'Γ' },
  { value: '\\Delta\\,', name: 'Δ' },
  { value: 'Ε', name: 'Ε' },
  { value: 'Ζ', name: 'Ζ' },
  { value: 'Η', name: 'Η' },
  { value: '\\Theta\\,', name: 'Θ' },
  { value: 'Ι', name: 'Ι' },
  { value: 'Κ', name: 'Κ' },
  { value: '\\Lambda\\,', name: 'Λ' },
  { value: 'Μ', name: 'Μ' },
  { value: 'Ν', name: 'Ν' },
  { value: '\\Xi\\,', name: 'Ξ' },
  { value: 'Ο', name: 'Ο' },
  { value: '\\Pi\\,', name: 'Π' },
  { value: 'Ρ', name: 'Ρ' },
  { value: '\\Sigma\\,', name: 'Σ' },
  { value: 'Τ', name: 'Τ' },
  { value: '\\Upsilon\\,', name: 'Υ' },
  { value: '\\Phi\\,', name: 'Φ' },
  { value: 'Χ', name: 'Χ' },
  { value: '\\Psi\\,', name: 'Ψ' },
  { value: '\\Omega\\,', name: 'Ω' },
];

export const relationsButtons = [
  { value: '<', name: '<' },
  { value: '>', name: '>' },
  { value: '\\nless\\,', name: '≮' },
  { value: '\\ngtr\\,', name: '≯' },
  { value: '\\leq\\,', name: '≤' },
  { value: '\\geq\\,', name: '≥' },
  { value: '\\leqslant\\,', name: '⩽' },
  { value: '\\nleq\\,', name: '≰' },
  { value: '\\ngeq\\,', name: '≱' },
  { value: '\\succ\\,', name: '≻' },
  { value: '\\nprec\\,', name: '⊀' },
  { value: '\\nsucc\\,', name: '⊁' },
  { value: '\\ll\\,', name: '≪' },
  { value: '\\gg\\,', name: '≫' },
  { value: '\\lll\\,', name: '⋘' },
  { value: '\\ggg\\,', name: '⋙' },
  { value: '\\subset\\,', name: '⊂' },
  { value: '\\supset\\,', name: '⊃' },
  { value: '\\not\\subset\\,', name: '⊄' },
  { value: '\\not\\supset\\,', name: '⊅' },
  { value: '\\subseteq\\,', name: '⊆' },
  { value: '\\supseteq\\,', name: '⊇' },
  { value: '\\nsubseteq\\,', name: '⊈' },
  { value: '\\nsupseteq\\,', name: '⊉' },
  { value: '\\sqsubset\\,', name: '⊏' },
  { value: '\\sqsupset\\,', name: '⊐' },
  { value: '\\sqsubseteq\\,', name: '⊑' },
  { value: '\\sqsupseteq\\,', name: '⊒' },
  { value: '\\equiv\\,', name: '≡' },
  { value: '\\neq\\,', name: '≠' },
  { value: '\\approx\\,', name: '≈' },
  { value: '\\cong\\,', name: '≅' },
  { value: '\\simeq\\,', name: '≃' },
  { value: '\\sim\\,', name: '∼' },
  { value: '\\propto\\,', name: '∝' },
  { value: '\\parallel\\,', name: '∥' },
  { value: '\\nparallel\\,', name: '∦' },
  { value: '\\in\\,', name: '∈' },
  { value: '\\ni\\,', name: '∋' },
  { value: '\\notin\\,', name: '∉' },
];

export const logicsButtons = [
  { value: '\\emptyset\\,', name: '∅' },
  { value: '\\N\\,', name: 'ℕ' },
  { value: '\\Z\\,', name: 'ℤ' },
  { value: '\\R\\,', name: 'ℝ' },
  { value: '\\in\\,', name: '∈' },
  { value: '\\ni\\,', name: '∋' },
  { value: '\\notin\\,', name: '∉' },
  { value: '\\exists\\,', name: '∃' },
  { value: '\\nexists\\,', name: '∄' },
  { value: '\\forall\\,', name: '∀' },
  { value: '\\neg\\,', name: '¬' },
  { value: '\\lor\\,', name: '∨' },
  { value: '\\land\\,', name: '∧' },
  { value: '\\cup\\,', name: '∪' },
  { value: '\\cap\\,', name: '∩' },
  { value: '\\Longrightarrow\\,', name: '⟹' },
  { value: '\\Longleftarrow\\,', name: '⟸' },
  { value: '\\Rightarrow\\,', name: '⇒' },
  { value: '\\Leftarrow\\,', name: '⇐' },
  { value: '\\iff\\,', name: '⟺' },
  { value: '\\Leftrightarrow\\,', name: '⇔' },
  { value: '\\top\\,', name: '⊤' },
  { value: '\\bot\\,', name: '⊥' },
];

export const calculusButtons = [
  { value: '\\displaystyle\\sum_{i=1}^n', name: '∑' },
  { value: '\\displaystyle\\prod_{i=1}^n', name: '∏' },
  { value: '\\infty\\,', name: '∞' },
  { value: '^\\prime', name: '′' },
  { value: '^{\\prime\\prime}', name: '″' },
  { value: '\\dot', name: '◌̇ ' },
  { value: '\\ddot', name: '◌̈' },
  { value: '\\partial', name: '∂' },
  { value: '\\to', name: '→' },
  { value: '\\lim_{x\\to\\infty}', name: 'lim' },
  { value: '\\int_{a}^{b}', name: '∫' },
  { value: '\\iint_v', name: '∬' },
  { value: '\\oint_v', name: '∮' },
  { value: '\\circ', name: '˚' },
  { value: '\\bar', name: '◌̄' },
  { value: '\\overline', name: '◌̅' },
  { value: '\\hat', name: '◌̂' },
];
